import React, { memo, useCallback } from "react";
import PropTypes from "prop-types";

function SelectBoxCheckBox({ canCheck, isChecked, onCheckedChange, name }) {
  const handleChange = useCallback(
    (event) => {
      if (canCheck) {
        onCheckedChange(event.target.checked);
      }
    },
    [onCheckedChange, canCheck],
  );

  return (
    <div className="selectbox-checkbox-container">
      <div className="editor-list-cell editor-list-select">
        <label className="checkbox">
          <input
            onChange={handleChange}
            checked={isChecked}
            name={name}
            type="checkbox"
            value={isChecked}
            className="checkbox-input"
            disabled={!canCheck}
          />
          <span className={`checkmark ${canCheck ? "" : "disabled"}`} />
        </label>
      </div>
    </div>
  );
}

SelectBoxCheckBox.propTypes = {
  canCheck: PropTypes.bool,
  isChecked: PropTypes.bool.isRequired,
  onCheckedChange: PropTypes.func,
  name: PropTypes.string, // name attribute of the checkbox
};

SelectBoxCheckBox.defaultProps = {
  canCheck: true,
  name: "name",
};

export default memo(SelectBoxCheckBox);
